import type { FC } from "react";

import { useTranslations } from "@jti/ui/providers/useTranslations";

import { ActionButtons } from "../../ActionButtons";

import styles from "./InstantLotteryConfirmation.module.scss";

type InstantLotteryConfirmationProps = {
  rewardName: string;
  onTryAgain?: () => void;
  onExploreMoreRewards?: () => void;
  isUserEligibleForReward?: boolean;
  isInstantLotteryWon?: boolean;
};

export const InstantLotteryConfirmation: FC<InstantLotteryConfirmationProps> = ({
  rewardName,
  onTryAgain,
  onExploreMoreRewards,
  isUserEligibleForReward,
  isInstantLotteryWon,
}) => {
  const { __ } = useTranslations();

  return (
    <>
      {isInstantLotteryWon && <span className={styles.prizeName}>{rewardName}</span>}
      <ActionButtons
        primaryButtonLabel={__("loyalty.redeemDialog.instant_lottery_physical.tryAgain")}
        secondaryButtonLabel={__("loyalty.redeemDialog.exploreMoreRewardsButtonText")}
        onPrimaryButtonClick={onTryAgain}
        onSecondaryButtonClick={onExploreMoreRewards}
        renderPrimaryButton={isUserEligibleForReward}
      />
    </>
  );
};
